export const N78_4 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Sales Performance (Product)",
        "binding": {
            "data": {
                "columns": [    
                    {
                        "name": 'Product Name',
                        "columnName": 'ItemName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Product Family',
                        "columnName": 'ItemFamilyName',
                        "width": '230px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'FY 1st Qtr',
                        "columnName": 'TY_Q1',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 1st Qtr',
                        "columnName": 'Target_Q1',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q1',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    
                     {
                        "name": 'FY 2nd Qtr',
                        "columnName": 'TY_Q2',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 2nd Qtr',
                        "columnName": 'Target_Q2',
                        "width": '160px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q2',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                     {
                        "name": 'FY 3rd Qtr',
                        "columnName": 'TY_Q3',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 3rd Qtr',
                        "columnName": 'Target_Q3',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q3',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'FY 4th Qtr',
                        "columnName": 'TY_Q4',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 4th Qtr',
                        "columnName": 'Target_Q4',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
             
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q4',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                ],
                "title": "DistrictManagerName",
                "endpoint": "N78.4",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}

export const N78_5 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Growth vs Last year by (Product)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Product Name',
                        "columnName": 'ItemName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Product Family',
                        "columnName": 'ItemFamilyName',
                        "width": '230px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'FY 1st Qtr',
                        "columnName": 'TY 1st Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 1st Qtr',
                        "columnName": 'LY 1st Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q1',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    
                    {
                        "name": 'FY 2nd Qtr',
                        "columnName": 'TY 2nd Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 2nd Qtr',
                        "columnName": 'LY 2nd Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q2',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'FY 3rd Qtr',
                        "columnName": 'TY 3rd Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 3rd Qtr',
                        "columnName": 'LY 3rd Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q3',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                    {
                        "name": 'FY 4th Qtr',
                        "columnName": 'TY 4th Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 4th Qtr',
                        "columnName": 'LY 4th Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q4',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                ],
                "title": "Product",
                "endpoint": "N78.5",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}

export const N78_6 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Sales Performance (Product Division)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Division Code',
                        "columnName": 'DivisionCode',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                     {
                        "name": 'FY 1st Qtr',
                        "columnName": 'TY_Q1',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 1st Qtr',
                        "columnName": 'Target_Q1',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q1',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    
                    {
                        "name": 'FY 2nd Qtr',
                        "columnName": 'TY_Q2',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 2nd Qtr',
                        "columnName": 'Target_Q2',
                        "width": '160px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q2',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'FY 3rd Qtr',
                        "columnName": 'TY_Q3',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 3rd Qtr',
                        "columnName": 'Target_Q3',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q3',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'FY 4th Qtr',
                        "columnName": 'TY_Q4',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 4th Qtr',
                        "columnName": 'Target_Q4',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q4',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                ],
                "title": "DistrictManagerName",
                "endpoint": "N78.6",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}

export const N78_7 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Growth vs Last year by (Product Division)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Division Code',
                        "columnName": 'DivisionCode',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'FY 1st Qtr',
                        "columnName": 'TY 1st Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 1st Qtr',
                        "columnName": 'LY 1st Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q1',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    
                    {
                        "name": 'FY 2nd Qtr',
                        "columnName": 'TY 2nd Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 2nd Qtr',
                        "columnName": 'LY 2nd Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q2',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'FY 3rd Qtr',
                        "columnName": 'TY 3rd Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 3rd Qtr',
                        "columnName": 'LY 3rd Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q3',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                    {
                        "name": 'FY 4th Qtr',
                        "columnName": 'TY 4th Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 4th Qtr',
                        "columnName": 'LY 4th Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q4',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                ],
                "title": "ProductDivision",
                "endpoint": "N78.7",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}

export const N78_8 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Sales Performance (Product Family)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Product Family',
                        "columnName": 'ItemFamilyName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'FY 1st Qtr',
                        "columnName": 'TY_Q1',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 1st Qtr',
                        "columnName": 'Target_Q1',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q1',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    
                     {
                        "name": 'FY 2nd Qtr',
                        "columnName": 'TY_Q2',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 2nd Qtr',
                        "columnName": 'Target_Q2',
                        "width": '160px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q2',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                     {
                        "name": 'FY 3rd Qtr',
                        "columnName": 'TY_Q3',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 3rd Qtr',
                        "columnName": 'Target_Q3',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q3',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                     {
                        "name": 'FY 4th Qtr',
                        "columnName": 'TY_Q4',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 4th Qtr',
                        "columnName": 'Target_Q4',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q4',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                ],
                "title": "DistrictManagerName",
                "endpoint": "N78.8",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}

export const N78_9 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Growth vs Last year by (Product Family)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Product Family',
                        "columnName": 'ItemFamilyName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'FY 1st Qtr',
                        "columnName": 'TY 1st Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 1st Qtr',
                        "columnName": 'LY 1st Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q1',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    
                    {
                        "name": 'FY 2nd Qtr',
                        "columnName": 'TY 2nd Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 2nd Qtr',
                        "columnName": 'LY 2nd Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q2',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'FY 3rd Qtr',
                        "columnName": 'TY 3rd Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 3rd Qtr',
                        "columnName": 'LY 3rd Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q3',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                    {
                        "name": 'FY 4th Qtr',
                        "columnName": 'TY 4th Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 4th Qtr',
                        "columnName": 'LY 4th Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q4',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                ],
                "title": "ProductDivision",
                "endpoint": "N78.9",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}



export const QuarterProduct = {
  "sections": [
    N78_4,
    N78_5,
    N78_6,
    N78_7,
    N78_8,
    N78_9
  ]
}